import React from 'react';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import i18n from '../../../i18n';
import 'dayjs/locale/pl';
import 'dayjs/locale/ru';
import 'dayjs/locale/uk';

const DateWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledDatePicker = styled(DatePicker)`
  max-width: 200px;
`;

export default function ViewsDatePicker({
  onStartDateChange,
  onEndDateChange,
  startDate,
  endDate,
  views,
  label,
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n?.language}>
      <Stack spacing={3}>
        <DateWrapper>
          <StyledDatePicker
            views={views}
            label={label}
            value={startDate}
            onChange={onStartDateChange}
            renderInput={(params) => (
              <TextField {...params} helperText={null} sx={{ marginRight: '10px' }} />
            )}
            sx={{ mr: '20px', paddingRight: '10px' }}
          />
          <StyledDatePicker
            views={views}
            label={label}
            value={endDate}
            onChange={onEndDateChange}
            renderInput={(params) => <TextField {...params} helperText={null} />}
          />
        </DateWrapper>
      </Stack>
    </LocalizationProvider>
  );
}
